import { render } from "./stored.vue?vue&type=template&id=35cc7c0e&scoped=true"
import script from "./stored.vue?vue&type=script&lang=js"
export * from "./stored.vue?vue&type=script&lang=js"

import "./stored.vue?vue&type=style&index=0&id=35cc7c0e&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cc7c0e"]])

export default __exports__